export default {
    getPartners: (state) => {
        return state.partners;
    },
    getLoadingPartners: (state) => {
        return state.loadingPartners;
    }
}